import { ShaderAccessorColorProperties } from './ShaderAccessorColorProperties';
import { ShaderAccessorColorMap } from './ShaderAccessorColorMap';
import { ShaderAccessorColorFlag } from './ShaderAccessorColorFlag';
/**
 * create for each layer one ShaderAccessor which contains one material, either for uni colors (labeling) or color maps (rssi, theta, phi, dist)
 */
export class ShaderAccessorFactory {
    constructor() {
        this._uniColorAccessor = new Map();
        this._mapColorAccessors = new Map();
    }
    get(ps, decoration, echoIdx) {
        let accessor = null;
        if (decoration.ColorMaps != null && decoration.ColorMaps.length > 0) {
            if (!this._mapColorAccessors.has(echoIdx)) {
                this._mapColorAccessors.set(echoIdx, new ShaderAccessorColorMap(echoIdx));
            }
            accessor = this._mapColorAccessors.get(echoIdx);
        }
        else if (ps.PropertiesValues != null) {
            if (!this._uniColorAccessor.has(echoIdx)) {
                this._uniColorAccessor.set(echoIdx, new ShaderAccessorColorProperties(echoIdx));
            }
            accessor = this._uniColorAccessor.get(echoIdx);
        }
        else if (ps.LabelValues != null) {
            if (!this._uniColorAccessor.has(echoIdx)) {
                this._uniColorAccessor.set(echoIdx, new ShaderAccessorColorFlag(echoIdx));
            }
            accessor = this._uniColorAccessor.get(echoIdx);
        }
        if (accessor == null) {
            return null;
        }
        accessor.setPolarScan(ps);
        return accessor;
    }
}
//# sourceMappingURL=ShaderAccessorFactory.js.map